// Chakra imports
import {
  Box,
  Flex,
  Select,
  Spinner,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import { apiurl } from "APIURL";
import axios from "axios";
import Card from "components/card/Card";
import PieChart from "components/charts/PieChart";
import { VSeparator } from "components/separator/Separator";
import { useEffect, useState } from "react";
import { pieChartOptions } from "variables/charts";

export default function Conversion(props: { [x: string]: any }) {
  const { ...rest } = props;
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${apiurl}/stats/allRevenues`);
        console.log(res.data);
        setData(res.data);
        setLoading(false);
      } catch (error) {}
    };
    getData();
  }, []);

  return (
    <Card
      p="20px"
      alignItems="center"
      flexDirection="column"
      w="100%"
      {...rest}
    >
      <Flex
        px={{ base: "0px", "2xl": "10px" }}
        justifyContent="space-between"
        alignItems="center"
        w="100%"
        mb="8px"
      >
        <Text color={textColor} fontSize="md" fontWeight="600" mt="4px">
          Statistiques
        </Text>
        <Select
          fontSize="sm"
          variant="subtle"
          defaultValue="monthly"
          width="unset"
          fontWeight="700"
        >
          <option value="daily">Quotidienne</option>
          <option value="monthly">Mensuelle</option>
          <option value="Annuelle">Annuelley</option>
        </Select>
      </Flex>
      {loading === true ? (
        <Spinner color="brand.500" />
      ) : (
        <>
          <PieChart
            h="100%"
            w="100%"
            chartData={[data?.professional_revenues, data?.stagiaire_revenues]}
            chartOptions={pieChartOptions}
          />
          <Card
            bg={cardColor}
            flexDirection="row"
            boxShadow={cardShadow}
            w="100%"
            p="15px"
            px="20px"
            mt="15px"
            mx="auto"
          >
            <Flex direction="column" py="5px">
              <Flex align="center">
                <Box
                  h="8px"
                  w="8px"
                  bg="brand.500"
                  borderRadius="50%"
                  me="4px"
                />
                <Text
                  fontSize="xs"
                  color="secondaryGray.600"
                  fontWeight="700"
                  mb="5px"
                >
                  Revenues de professionels
                </Text>
              </Flex>
              <Text fontSize="lg" color={textColor} fontWeight="700">
                {data?.professional_revenues}
              </Text>
            </Flex>
            <VSeparator mx={{ base: "60px", xl: "60px", "2xl": "60px" }} />
            <Flex direction="column" py="5px" me="10px">
              <Flex align="center">
                <Box h="8px" w="8px" bg="#6AD2FF" borderRadius="50%" me="4px" />
                <Text
                  fontSize="xs"
                  color="secondaryGray.600"
                  fontWeight="700"
                  mb="5px"
                >
                  Revenues de stagiaires
                </Text>
              </Flex>
              <Text fontSize="lg" color={textColor} fontWeight="700">
                {data?.stagiaire_revenues}
              </Text>
            </Flex>
          </Card>
        </>
      )}
    </Card>
  );
}
